import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import TeamRepository from '../Repositories/TeamRepository'

class TeamBloc
{   
    repository = new TeamRepository()
    timkerjaPeriodChannel = new Subject()
    timkerjaPeriodCreateChannel = new Subject()
    timkerjaPeriodDeleteChannel = new Subject()
    timkerjaTeamListChannel = new Subject()
    timkerjaTeamCreateChannel = new Subject()
    timkerjaMembersChannel = new Subject()
    timkerjaMemberCreateChannel = new Subject()
    timkerjaMemberLeaderChannel = new Subject()
    timkerjaDeleteChannel = new Subject()
    timkerjaDeleteMemberChannel = new Subject()
    timkerjaActivateChannel = new Subject()
    timkerjaOrgranizationChannel = new Subject()
    timkerjaLeaderChannel = new Subject()
    timkerjaDetailTeamChannel = new Subject()
    timkerjaGenerateChannel = new Subject()
    timkerjaGroupMemberChannel = new Subject()
    timkerjaConfigUpdateChannel = new Subject()
    timkerjaDownloadChannel = new Subject()
    timkerjaImportChannel = new Subject()
    timkerjaSyncChannel = new Subject()
    timkerjaTemplateChannel = new Subject()
    timkerjaUnitKerjaChannel = new Subject()
    timkerjaDeleteAllChannel = new Subject()
   

    constructor() {
        this.timkerjaPeriodChannel.next({status: apiResponse.INITIAL})
        this.timkerjaPeriodCreateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaTeamListChannel.next({status: apiResponse.INITIAL})
        this.timkerjaTeamCreateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaMembersChannel.next({status: apiResponse.INITIAL})
        this.timkerjaMemberCreateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaMemberLeaderChannel.next({status: apiResponse.INITIAL})
        this.timkerjaDeleteChannel.next({status: apiResponse.INITIAL})
        this.timkerjaDeleteMemberChannel.next({status: apiResponse.INITIAL})
        this.timkerjaActivateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaPeriodDeleteChannel.next({status: apiResponse.INITIAL})
        this.timkerjaOrgranizationChannel.next({status: apiResponse.INITIAL})
        this.timkerjaLeaderChannel.next({status: apiResponse.INITIAL})
        this.timkerjaDetailTeamChannel.next({status: apiResponse.INITIAL})
        this.timkerjaGenerateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaGroupMemberChannel.next({status: apiResponse.INITIAL})
        this.timkerjaConfigUpdateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaDownloadChannel.next({status: apiResponse.INITIAL})
        this.timkerjaSyncChannel.next({status: apiResponse.INITIAL})
        this.timkerjaTemplateChannel.next({status: apiResponse.INITIAL})
        this.timkerjaUnitKerjaChannel.next({status: apiResponse.INITIAL})
        this.timkerjaDeleteAllChannel.next({status: apiResponse.INITIAL})
    }

   

    fetchDeleteAll = async (query) => {
        this.timkerjaDeleteAllChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDeleteAll(query).then((result) => {
            this.timkerjaDeleteAllChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaDeleteAllChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUnitKerja = async (query) => {
        this.timkerjaUnitKerjaChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUnitKerja(query).then((result) => {
            this.timkerjaUnitKerjaChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaUnitKerjaChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTemplate = async (query) => {
        this.timkerjaTemplateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTemplate(query).then((result) => {
            this.timkerjaTemplateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaTemplateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSync = async (query) => {
        this.timkerjaSyncChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSync(query).then((result) => {
            this.timkerjaSyncChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaSyncChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchImport = async (query) => {
        this.timkerjaImportChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchImport(query).then((result) => {
            this.timkerjaImportChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaImportChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchDownload = async (query) => {
        this.timkerjaDownloadChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDownload(query).then((result) => {
            this.timkerjaDownloadChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaDownloadChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchConfigUpdate = async (query) => {
        this.timkerjaConfigUpdateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchConfigUpdate(query).then((result) => {
            this.timkerjaConfigUpdateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaConfigUpdateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchGroupMember = async (query) => {
        this.timkerjaGroupMemberChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGroupMember(query).then((result) => {
            this.timkerjaGroupMemberChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaGroupMemberChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchGenerate = async (query) => {
        this.timkerjaGenerateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerate(query).then((result) => {
            this.timkerjaGenerateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaGenerateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchDetailTeam = async (query, cancelToken) => {
        this.timkerjaDetailTeamChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailTeam(query, cancelToken).then((result) => {
            this.timkerjaDetailTeamChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaDetailTeamChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchLeader = async (query, cancelToken) => {
        this.timkerjaLeaderChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchLeader(query, cancelToken).then((result) => {
            this.timkerjaLeaderChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaLeaderChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchOrganization = async (query, cancelToken) => {
        this.timkerjaOrgranizationChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchOrganization(query, cancelToken).then((result) => {
            this.timkerjaOrgranizationChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaOrgranizationChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchPeriodDelete = async (query) => {
        this.timkerjaPeriodDeleteChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPeriodDelete(query).then((result) => {
            this.timkerjaPeriodDeleteChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaPeriodDeleteChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPeriod = async (query, cancelToken) => {
        this.timkerjaPeriodChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPeriod(query, cancelToken).then((result) => {
            this.timkerjaPeriodChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaPeriodChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPeriodCreate = async (query) => {
        this.timkerjaPeriodCreateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPeriodCreate(query).then((result) => {
            this.timkerjaPeriodCreateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaPeriodCreateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTeamList = async (query, cancelToken) => {
        this.timkerjaTeamListChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTeamList(query, cancelToken).then((result) => {
            this.timkerjaTeamListChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaTeamListChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTeamCreate = async (query) => {
        this.timkerjaTeamCreateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTeamCreate(query).then((result) => {
            this.timkerjaTeamCreateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaTeamCreateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchMembers = async (query) => {
        this.timkerjaMembersChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMembers(query).then((result) => {
            this.timkerjaMembersChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaMembersChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchMemberCreate = async (query) => {
        this.timkerjaMemberCreateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMemberCreate(query).then((result) => {
            this.timkerjaMemberCreateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaMemberCreateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchMemberLeader = async (query) => {
        this.timkerjaMemberLeaderChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMemberLeader(query).then((result) => {
            this.timkerjaMemberLeaderChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaMemberLeaderChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTeamDelete = async (query) => {
        this.timkerjaDeleteChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTeamDelete(query).then((result) => {
            this.timkerjaDeleteChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaDeleteChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTeamDeleteMember = async (query) => {
        this.timkerjaDeleteMemberChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTeamDeleteMember(query).then((result) => {
            this.timkerjaDeleteMemberChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaDeleteMemberChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTeamActivate = async (query) => {
        this.timkerjaActivateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTeamActivate(query).then((result) => {
            this.timkerjaActivateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.timkerjaActivateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
      
}

export default TeamBloc